/**
 * KNOWLEDGE
 */
export const SET_FOCUS_KNOWLEDGE = 'SET_FOCUS_KNOWLEDGE';
export const INIT_KNOWLEDGE = 'INIT_KNOWLEDGE';
export const UPDATE_KNOWLEDGE = 'UPDATE_KNOWLEDGE';
